import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'

export interface IReleaseYearBadgeProps {
  releaseYear?: number
}

export const ReleaseYear = ({ releaseYear }: IReleaseYearBadgeProps) => (
  releaseYear && (
    <Badge use={badges.TEXT}>
      <span data-automation-id="release-year-badge">{releaseYear}</span>
    </Badge>) || null
)
